"use client";

import { useQuery } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import { useAxios } from "@/app/providers/AxiosProvider";
import { useSignalsAccess } from "./useSignals";
import type { CandidateDossier } from "./types";

/** The latest public dossier research assembled for a candidate (null until research finishes). */
export function useCandidateDossier(candidateId: string) {
  const api = useAxios() as AxiosInstance;
  const access = useSignalsAccess();
  return useQuery({
    queryKey: ["signal-dossier", access.scope, candidateId],
    queryFn: async ({ signal }) => (await api.get<{ data: CandidateDossier | null }>(`/signals/research/${candidateId}/dossier`, { signal })).data.data,
    enabled: access.enabled && /^\d+$/.test(candidateId), staleTime: 5 * 60_000, retry: false,
  });
}
